export default class Owner {
  constructor () {
    this.setInitialValue()
  }

  setInitialValue () {
    this.silk_image = ''
    this.silk_imageUrl = null
    this.translations = [
      { id: null, name: '', lang: 'ar' },
      { id: null, name: '', lang: 'en' }
    ]
  }

  fillData (data) {
    if (data) {
      const itemAr = data.translations?.find(o => o.lang === 'ar')
      const itemEn = data.translations?.find(o => o.lang === 'en')

      this.silk_imageUrl = data.silk_image ? data.silk_image : null
      this.translations[0].id = itemAr ? itemAr.id : null
      this.translations[0].name = itemAr ? itemAr.name : ''
      this.translations[1].id = itemEn ? itemEn.id : null
      this.translations[1].name = itemEn ? itemEn.name : ''
    } else {
      this.setInitialValue()
    }
  }
}
